import React from 'react';
import ReactDOM from 'react-dom';
import breakpoints from '../../../shared/breakpoints';

export default function ThroughPortal(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        showPortal: breakpoints.upTo_medium(),
      };
    }

    componentDidMount() {
      $(window).on('resize', () => {
        this.setState({
          showPortal: breakpoints.upTo_medium(),
        });
      });
    }

    componentWillUnmount() {
      $(window).off('resize');
    }

    render() {
      return this.state.showPortal ? (
        ReactDOM.createPortal(
          <WrappedComponent {...this.props} />,
          document.querySelector('#portal-target'),
        )
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };
}
